/* eslint-disable */
// Auto-generated by src/sripts/generate-images.js

import _1_avif_480_1 from "./restaurant/slider/1-480.avif";
import _1_avif_768_2 from "./restaurant/slider/1-768.avif";
import _1_avif_1200_3 from "./restaurant/slider/1-1200.avif";
import _1_avif_1920_4 from "./restaurant/slider/1-1920.avif";
import _1_webp_480_5 from "./restaurant/slider/1-480.webp";
import _1_webp_768_6 from "./restaurant/slider/1-768.webp";
import _1_webp_1200_7 from "./restaurant/slider/1-1200.webp";
import _1_webp_1920_8 from "./restaurant/slider/1-1920.webp";
import _1_jpg_480_9 from "./restaurant/slider/1-480.jpg";
import _1_jpg_768_10 from "./restaurant/slider/1-768.jpg";
import _1_jpg_1200_11 from "./restaurant/slider/1-1200.jpg";
import _1_jpg_1920_12 from "./restaurant/slider/1-1920.jpg";
import _2_avif_480_13 from "./restaurant/slider/2-480.avif";
import _2_avif_768_14 from "./restaurant/slider/2-768.avif";
import _2_avif_1200_15 from "./restaurant/slider/2-1200.avif";
import _2_avif_1920_16 from "./restaurant/slider/2-1920.avif";
import _2_webp_480_17 from "./restaurant/slider/2-480.webp";
import _2_webp_768_18 from "./restaurant/slider/2-768.webp";
import _2_webp_1200_19 from "./restaurant/slider/2-1200.webp";
import _2_webp_1920_20 from "./restaurant/slider/2-1920.webp";
import _2_jpg_480_21 from "./restaurant/slider/2-480.jpg";
import _2_jpg_768_22 from "./restaurant/slider/2-768.jpg";
import _2_jpg_1200_23 from "./restaurant/slider/2-1200.jpg";
import _2_jpg_1920_24 from "./restaurant/slider/2-1920.jpg";
import _3_avif_480_25 from "./restaurant/slider/3-480.avif";
import _3_avif_768_26 from "./restaurant/slider/3-768.avif";
import _3_avif_1200_27 from "./restaurant/slider/3-1200.avif";
import _3_avif_1920_28 from "./restaurant/slider/3-1920.avif";
import _3_webp_480_29 from "./restaurant/slider/3-480.webp";
import _3_webp_768_30 from "./restaurant/slider/3-768.webp";
import _3_webp_1200_31 from "./restaurant/slider/3-1200.webp";
import _3_webp_1920_32 from "./restaurant/slider/3-1920.webp";
import _3_jpg_480_33 from "./restaurant/slider/3-480.jpg";
import _3_jpg_768_34 from "./restaurant/slider/3-768.jpg";
import _3_jpg_1200_35 from "./restaurant/slider/3-1200.jpg";
import _3_jpg_1920_36 from "./restaurant/slider/3-1920.jpg";
import _4_avif_480_37 from "./restaurant/slider/4-480.avif";
import _4_avif_768_38 from "./restaurant/slider/4-768.avif";
import _4_avif_1200_39 from "./restaurant/slider/4-1200.avif";
import _4_avif_1920_40 from "./restaurant/slider/4-1920.avif";
import _4_webp_480_41 from "./restaurant/slider/4-480.webp";
import _4_webp_768_42 from "./restaurant/slider/4-768.webp";
import _4_webp_1200_43 from "./restaurant/slider/4-1200.webp";
import _4_webp_1920_44 from "./restaurant/slider/4-1920.webp";
import _4_jpg_480_45 from "./restaurant/slider/4-480.jpg";
import _4_jpg_768_46 from "./restaurant/slider/4-768.jpg";
import _4_jpg_1200_47 from "./restaurant/slider/4-1200.jpg";
import _4_jpg_1920_48 from "./restaurant/slider/4-1920.jpg";
import _5_avif_480_49 from "./restaurant/slider/5-480.avif";
import _5_avif_768_50 from "./restaurant/slider/5-768.avif";
import _5_avif_1200_51 from "./restaurant/slider/5-1200.avif";
import _5_avif_1920_52 from "./restaurant/slider/5-1920.avif";
import _5_webp_480_53 from "./restaurant/slider/5-480.webp";
import _5_webp_768_54 from "./restaurant/slider/5-768.webp";
import _5_webp_1200_55 from "./restaurant/slider/5-1200.webp";
import _5_webp_1920_56 from "./restaurant/slider/5-1920.webp";
import _5_jpg_480_57 from "./restaurant/slider/5-480.jpg";
import _5_jpg_768_58 from "./restaurant/slider/5-768.jpg";
import _5_jpg_1200_59 from "./restaurant/slider/5-1200.jpg";
import _5_jpg_1920_60 from "./restaurant/slider/5-1920.jpg";
import _6_avif_480_61 from "./restaurant/slider/6-480.avif";
import _6_avif_768_62 from "./restaurant/slider/6-768.avif";
import _6_avif_1200_63 from "./restaurant/slider/6-1200.avif";
import _6_avif_1920_64 from "./restaurant/slider/6-1920.avif";
import _6_webp_480_65 from "./restaurant/slider/6-480.webp";
import _6_webp_768_66 from "./restaurant/slider/6-768.webp";
import _6_webp_1200_67 from "./restaurant/slider/6-1200.webp";
import _6_webp_1920_68 from "./restaurant/slider/6-1920.webp";
import _6_jpg_480_69 from "./restaurant/slider/6-480.jpg";
import _6_jpg_768_70 from "./restaurant/slider/6-768.jpg";
import _6_jpg_1200_71 from "./restaurant/slider/6-1200.jpg";
import _6_jpg_1920_72 from "./restaurant/slider/6-1920.jpg";
import _7_avif_480_73 from "./restaurant/slider/7-480.avif";
import _7_avif_768_74 from "./restaurant/slider/7-768.avif";
import _7_avif_1200_75 from "./restaurant/slider/7-1200.avif";
import _7_avif_1920_76 from "./restaurant/slider/7-1920.avif";
import _7_webp_480_77 from "./restaurant/slider/7-480.webp";
import _7_webp_768_78 from "./restaurant/slider/7-768.webp";
import _7_webp_1200_79 from "./restaurant/slider/7-1200.webp";
import _7_webp_1920_80 from "./restaurant/slider/7-1920.webp";
import _7_jpg_480_81 from "./restaurant/slider/7-480.jpg";
import _7_jpg_768_82 from "./restaurant/slider/7-768.jpg";
import _7_jpg_1200_83 from "./restaurant/slider/7-1200.jpg";
import _7_jpg_1920_84 from "./restaurant/slider/7-1920.jpg";
import _8_avif_480_85 from "./restaurant/slider/8-480.avif";
import _8_avif_768_86 from "./restaurant/slider/8-768.avif";
import _8_avif_1200_87 from "./restaurant/slider/8-1200.avif";
import _8_avif_1920_88 from "./restaurant/slider/8-1920.avif";
import _8_webp_480_89 from "./restaurant/slider/8-480.webp";
import _8_webp_768_90 from "./restaurant/slider/8-768.webp";
import _8_webp_1200_91 from "./restaurant/slider/8-1200.webp";
import _8_webp_1920_92 from "./restaurant/slider/8-1920.webp";
import _8_jpg_480_93 from "./restaurant/slider/8-480.jpg";
import _8_jpg_768_94 from "./restaurant/slider/8-768.jpg";
import _8_jpg_1200_95 from "./restaurant/slider/8-1200.jpg";
import _8_jpg_1920_96 from "./restaurant/slider/8-1920.jpg";
import _9_avif_480_97 from "./restaurant/slider/9-480.avif";
import _9_avif_768_98 from "./restaurant/slider/9-768.avif";
import _9_avif_1200_99 from "./restaurant/slider/9-1200.avif";
import _9_avif_1920_100 from "./restaurant/slider/9-1920.avif";
import _9_webp_480_101 from "./restaurant/slider/9-480.webp";
import _9_webp_768_102 from "./restaurant/slider/9-768.webp";
import _9_webp_1200_103 from "./restaurant/slider/9-1200.webp";
import _9_webp_1920_104 from "./restaurant/slider/9-1920.webp";
import _9_jpg_480_105 from "./restaurant/slider/9-480.jpg";
import _9_jpg_768_106 from "./restaurant/slider/9-768.jpg";
import _9_jpg_1200_107 from "./restaurant/slider/9-1200.jpg";
import _9_jpg_1920_108 from "./restaurant/slider/9-1920.jpg";
import _10_avif_480_109 from "./restaurant/slider/10-480.avif";
import _10_avif_768_110 from "./restaurant/slider/10-768.avif";
import _10_avif_1200_111 from "./restaurant/slider/10-1200.avif";
import _10_avif_1920_112 from "./restaurant/slider/10-1920.avif";
import _10_webp_480_113 from "./restaurant/slider/10-480.webp";
import _10_webp_768_114 from "./restaurant/slider/10-768.webp";
import _10_webp_1200_115 from "./restaurant/slider/10-1200.webp";
import _10_webp_1920_116 from "./restaurant/slider/10-1920.webp";
import _10_jpg_480_117 from "./restaurant/slider/10-480.jpg";
import _10_jpg_768_118 from "./restaurant/slider/10-768.jpg";
import _10_jpg_1200_119 from "./restaurant/slider/10-1200.jpg";
import _10_jpg_1920_120 from "./restaurant/slider/10-1920.jpg";
import _11_avif_480_121 from "./restaurant/slider/11-480.avif";
import _11_avif_768_122 from "./restaurant/slider/11-768.avif";
import _11_avif_1200_123 from "./restaurant/slider/11-1200.avif";
import _11_avif_1920_124 from "./restaurant/slider/11-1920.avif";
import _11_webp_480_125 from "./restaurant/slider/11-480.webp";
import _11_webp_768_126 from "./restaurant/slider/11-768.webp";
import _11_webp_1200_127 from "./restaurant/slider/11-1200.webp";
import _11_webp_1920_128 from "./restaurant/slider/11-1920.webp";
import _11_jpg_480_129 from "./restaurant/slider/11-480.jpg";
import _11_jpg_768_130 from "./restaurant/slider/11-768.jpg";
import _11_jpg_1200_131 from "./restaurant/slider/11-1200.jpg";
import _11_jpg_1920_132 from "./restaurant/slider/11-1920.jpg";
import _12_avif_480_133 from "./restaurant/slider/12-480.avif";
import _12_avif_768_134 from "./restaurant/slider/12-768.avif";
import _12_avif_1200_135 from "./restaurant/slider/12-1200.avif";
import _12_avif_1920_136 from "./restaurant/slider/12-1920.avif";
import _12_webp_480_137 from "./restaurant/slider/12-480.webp";
import _12_webp_768_138 from "./restaurant/slider/12-768.webp";
import _12_webp_1200_139 from "./restaurant/slider/12-1200.webp";
import _12_webp_1920_140 from "./restaurant/slider/12-1920.webp";
import _12_jpg_480_141 from "./restaurant/slider/12-480.jpg";
import _12_jpg_768_142 from "./restaurant/slider/12-768.jpg";
import _12_jpg_1200_143 from "./restaurant/slider/12-1200.jpg";
import _12_jpg_1920_144 from "./restaurant/slider/12-1920.jpg";
import _13_avif_480_145 from "./restaurant/slider/13-480.avif";
import _13_avif_768_146 from "./restaurant/slider/13-768.avif";
import _13_avif_1200_147 from "./restaurant/slider/13-1200.avif";
import _13_avif_1920_148 from "./restaurant/slider/13-1920.avif";
import _13_webp_480_149 from "./restaurant/slider/13-480.webp";
import _13_webp_768_150 from "./restaurant/slider/13-768.webp";
import _13_webp_1200_151 from "./restaurant/slider/13-1200.webp";
import _13_webp_1920_152 from "./restaurant/slider/13-1920.webp";
import _13_jpg_480_153 from "./restaurant/slider/13-480.jpg";
import _13_jpg_768_154 from "./restaurant/slider/13-768.jpg";
import _13_jpg_1200_155 from "./restaurant/slider/13-1200.jpg";
import _13_jpg_1920_156 from "./restaurant/slider/13-1920.jpg";
import _14_avif_480_157 from "./restaurant/slider/14-480.avif";
import _14_avif_768_158 from "./restaurant/slider/14-768.avif";
import _14_avif_1200_159 from "./restaurant/slider/14-1200.avif";
import _14_avif_1920_160 from "./restaurant/slider/14-1920.avif";
import _14_webp_480_161 from "./restaurant/slider/14-480.webp";
import _14_webp_768_162 from "./restaurant/slider/14-768.webp";
import _14_webp_1200_163 from "./restaurant/slider/14-1200.webp";
import _14_webp_1920_164 from "./restaurant/slider/14-1920.webp";
import _14_jpg_480_165 from "./restaurant/slider/14-480.jpg";
import _14_jpg_768_166 from "./restaurant/slider/14-768.jpg";
import _14_jpg_1200_167 from "./restaurant/slider/14-1200.jpg";
import _14_jpg_1920_168 from "./restaurant/slider/14-1920.jpg";

const images = {
  "1": {
    "avif": {
      "480": _1_avif_480_1,
      "768": _1_avif_768_2,
      "1200": _1_avif_1200_3,
      "1920": _1_avif_1920_4,
    },
    "webp": {
      "480": _1_webp_480_5,
      "768": _1_webp_768_6,
      "1200": _1_webp_1200_7,
      "1920": _1_webp_1920_8,
    },
    "jpg": {
      "480": _1_jpg_480_9,
      "768": _1_jpg_768_10,
      "1200": _1_jpg_1200_11,
      "1920": _1_jpg_1920_12,
    },
  },
  "2": {
    "avif": {
      "480": _2_avif_480_13,
      "768": _2_avif_768_14,
      "1200": _2_avif_1200_15,
      "1920": _2_avif_1920_16,
    },
    "webp": {
      "480": _2_webp_480_17,
      "768": _2_webp_768_18,
      "1200": _2_webp_1200_19,
      "1920": _2_webp_1920_20,
    },
    "jpg": {
      "480": _2_jpg_480_21,
      "768": _2_jpg_768_22,
      "1200": _2_jpg_1200_23,
      "1920": _2_jpg_1920_24,
    },
  },
  "3": {
    "avif": {
      "480": _3_avif_480_25,
      "768": _3_avif_768_26,
      "1200": _3_avif_1200_27,
      "1920": _3_avif_1920_28,
    },
    "webp": {
      "480": _3_webp_480_29,
      "768": _3_webp_768_30,
      "1200": _3_webp_1200_31,
      "1920": _3_webp_1920_32,
    },
    "jpg": {
      "480": _3_jpg_480_33,
      "768": _3_jpg_768_34,
      "1200": _3_jpg_1200_35,
      "1920": _3_jpg_1920_36,
    },
  },
  "4": {
    "avif": {
      "480": _4_avif_480_37,
      "768": _4_avif_768_38,
      "1200": _4_avif_1200_39,
      "1920": _4_avif_1920_40,
    },
    "webp": {
      "480": _4_webp_480_41,
      "768": _4_webp_768_42,
      "1200": _4_webp_1200_43,
      "1920": _4_webp_1920_44,
    },
    "jpg": {
      "480": _4_jpg_480_45,
      "768": _4_jpg_768_46,
      "1200": _4_jpg_1200_47,
      "1920": _4_jpg_1920_48,
    },
  },
  "5": {
    "avif": {
      "480": _5_avif_480_49,
      "768": _5_avif_768_50,
      "1200": _5_avif_1200_51,
      "1920": _5_avif_1920_52,
    },
    "webp": {
      "480": _5_webp_480_53,
      "768": _5_webp_768_54,
      "1200": _5_webp_1200_55,
      "1920": _5_webp_1920_56,
    },
    "jpg": {
      "480": _5_jpg_480_57,
      "768": _5_jpg_768_58,
      "1200": _5_jpg_1200_59,
      "1920": _5_jpg_1920_60,
    },
  },
  "6": {
    "avif": {
      "480": _6_avif_480_61,
      "768": _6_avif_768_62,
      "1200": _6_avif_1200_63,
      "1920": _6_avif_1920_64,
    },
    "webp": {
      "480": _6_webp_480_65,
      "768": _6_webp_768_66,
      "1200": _6_webp_1200_67,
      "1920": _6_webp_1920_68,
    },
    "jpg": {
      "480": _6_jpg_480_69,
      "768": _6_jpg_768_70,
      "1200": _6_jpg_1200_71,
      "1920": _6_jpg_1920_72,
    },
  },
  "7": {
    "avif": {
      "480": _7_avif_480_73,
      "768": _7_avif_768_74,
      "1200": _7_avif_1200_75,
      "1920": _7_avif_1920_76,
    },
    "webp": {
      "480": _7_webp_480_77,
      "768": _7_webp_768_78,
      "1200": _7_webp_1200_79,
      "1920": _7_webp_1920_80,
    },
    "jpg": {
      "480": _7_jpg_480_81,
      "768": _7_jpg_768_82,
      "1200": _7_jpg_1200_83,
      "1920": _7_jpg_1920_84,
    },
  },
  "8": {
    "avif": {
      "480": _8_avif_480_85,
      "768": _8_avif_768_86,
      "1200": _8_avif_1200_87,
      "1920": _8_avif_1920_88,
    },
    "webp": {
      "480": _8_webp_480_89,
      "768": _8_webp_768_90,
      "1200": _8_webp_1200_91,
      "1920": _8_webp_1920_92,
    },
    "jpg": {
      "480": _8_jpg_480_93,
      "768": _8_jpg_768_94,
      "1200": _8_jpg_1200_95,
      "1920": _8_jpg_1920_96,
    },
  },
  "9": {
    "avif": {
      "480": _9_avif_480_97,
      "768": _9_avif_768_98,
      "1200": _9_avif_1200_99,
      "1920": _9_avif_1920_100,
    },
    "webp": {
      "480": _9_webp_480_101,
      "768": _9_webp_768_102,
      "1200": _9_webp_1200_103,
      "1920": _9_webp_1920_104,
    },
    "jpg": {
      "480": _9_jpg_480_105,
      "768": _9_jpg_768_106,
      "1200": _9_jpg_1200_107,
      "1920": _9_jpg_1920_108,
    },
  },
  "10": {
    "avif": {
      "480": _10_avif_480_109,
      "768": _10_avif_768_110,
      "1200": _10_avif_1200_111,
      "1920": _10_avif_1920_112,
    },
    "webp": {
      "480": _10_webp_480_113,
      "768": _10_webp_768_114,
      "1200": _10_webp_1200_115,
      "1920": _10_webp_1920_116,
    },
    "jpg": {
      "480": _10_jpg_480_117,
      "768": _10_jpg_768_118,
      "1200": _10_jpg_1200_119,
      "1920": _10_jpg_1920_120,
    },
  },
  "11": {
    "avif": {
      "480": _11_avif_480_121,
      "768": _11_avif_768_122,
      "1200": _11_avif_1200_123,
      "1920": _11_avif_1920_124,
    },
    "webp": {
      "480": _11_webp_480_125,
      "768": _11_webp_768_126,
      "1200": _11_webp_1200_127,
      "1920": _11_webp_1920_128,
    },
    "jpg": {
      "480": _11_jpg_480_129,
      "768": _11_jpg_768_130,
      "1200": _11_jpg_1200_131,
      "1920": _11_jpg_1920_132,
    },
  },
  "12": {
    "avif": {
      "480": _12_avif_480_133,
      "768": _12_avif_768_134,
      "1200": _12_avif_1200_135,
      "1920": _12_avif_1920_136,
    },
    "webp": {
      "480": _12_webp_480_137,
      "768": _12_webp_768_138,
      "1200": _12_webp_1200_139,
      "1920": _12_webp_1920_140,
    },
    "jpg": {
      "480": _12_jpg_480_141,
      "768": _12_jpg_768_142,
      "1200": _12_jpg_1200_143,
      "1920": _12_jpg_1920_144,
    },
  },
  "13": {
    "avif": {
      "480": _13_avif_480_145,
      "768": _13_avif_768_146,
      "1200": _13_avif_1200_147,
      "1920": _13_avif_1920_148,
    },
    "webp": {
      "480": _13_webp_480_149,
      "768": _13_webp_768_150,
      "1200": _13_webp_1200_151,
      "1920": _13_webp_1920_152,
    },
    "jpg": {
      "480": _13_jpg_480_153,
      "768": _13_jpg_768_154,
      "1200": _13_jpg_1200_155,
      "1920": _13_jpg_1920_156,
    },
  },
  "14": {
    "avif": {
      "480": _14_avif_480_157,
      "768": _14_avif_768_158,
      "1200": _14_avif_1200_159,
      "1920": _14_avif_1920_160,
    },
    "webp": {
      "480": _14_webp_480_161,
      "768": _14_webp_768_162,
      "1200": _14_webp_1200_163,
      "1920": _14_webp_1920_164,
    },
    "jpg": {
      "480": _14_jpg_480_165,
      "768": _14_jpg_768_166,
      "1200": _14_jpg_1200_167,
      "1920": _14_jpg_1920_168,
    },
  },
};

export default images;
